// extracted by mini-css-extract-plugin
export default {"icon":"Favorite_icon__dq3au"};